import apiUrl from "./config/config";
import axios from "axios";

class variableApi
{

  //Get variables
  static async getVariables(params)
  {

    try
    {

      const response = await axios(apiUrl + "variable", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get a variable by id
  static async getVariable(id)
  {

    try
    {

      const response = await axios(apiUrl + `variable/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  static async getVariableTypes(params)
  {

    try
    {

      const response = await axios(apiUrl + "variable/type", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Update a variable
  static async updateVariable(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "variable", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a variable
  static async deleteVariable(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `variable/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

}






export default variableApi;